// Preserves unsaved form text when a session expires, so nothing typed is lost.
const KEY = "dhdh_saved_draft";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;
const TEXT_TYPES = new Set(["text", "email", "url", "number", "search", "tel", "date", "time", "datetime-local", ""]);

const fieldKey = (el) => el.getAttribute("data-testid") || el.id || el.name || null;

export const snapshotDrafts = (failedRequest) => {
  try {
    const fields = [];
    document.querySelectorAll("textarea, input").forEach((el) => {
      if (el.tagName === "INPUT" && !TEXT_TYPES.has((el.getAttribute("type") || "").toLowerCase())) return;
      const key = fieldKey(el);
      const value = el.value;
      if (key && /pass(word)?|pwd|secret|token|card/i.test(key)) return;
      if (key && value && value.trim()) fields.push({ key, value, label: el.getAttribute("placeholder") || el.getAttribute("aria-label") || key });
    });
    document.querySelectorAll(".ql-editor").forEach((el, i) => {
      const text = el.innerText?.trim();
      if (text) fields.push({ key: `rich-editor-${i}`, value: text, label: "Rich text", copyOnly: true });
    });
    let request = null;
    if (failedRequest && ["post", "put", "patch"].includes((failedRequest.method || "").toLowerCase())) {
      const body = typeof failedRequest.data === "string" ? failedRequest.data : null;
      // Never persist credentials or secrets.
      if (body && body.length < 20000 && !/pass(word)?|token|secret/i.test(body)) request = { url: failedRequest.url, method: failedRequest.method, body };
    }
    if (!fields.length && !request) return false;
    const prev = loadDraft();
    const path = window.location.pathname + window.location.search;
    const merged = prev && prev.path === path ? [...prev.fields.filter((f) => !fields.some((n) => n.key === f.key)), ...fields] : fields;
    localStorage.setItem(KEY, JSON.stringify({ path, fields: merged, request: request || prev?.request || null, saved_at: Date.now(), user_id: window.__dhdh_uid || null }));
    return true;
  } catch { return false; }
};

export const loadDraft = (userId) => {
  try {
    const d = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!d || Date.now() - d.saved_at > MAX_AGE_MS) return null;
    if (userId && d.user_id && d.user_id !== userId) { localStorage.removeItem(KEY); return null; }
    return d;
  } catch { return null; }
};

export const clearDraft = () => localStorage.removeItem(KEY);

// Fill a React-controlled field so React state updates too.
export const fillField = (el, value) => {
  const proto = el.tagName === "TEXTAREA" ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
  Object.getOwnPropertyDescriptor(proto, "value").set.call(el, value);
  el.dispatchEvent(new Event("input", { bubbles: true }));
};

export const findField = (key) => {
  const esc = window.CSS?.escape ? window.CSS.escape(key) : key;
  return document.querySelector(`[data-testid="${esc}"], #${esc}, [name="${esc}"]`);
};
